import React, { forwardRef, useImperativeHandle, useState } from "react";
import { BottomSheet } from "@rneui/base";
import moment from "moment";
import {
  DATE_FORMAT,
  DATE_FORMAT_SELECTED,
  SCREEN_WIDTH,
  TABLET_PC,
} from "libs/utils/constants";
import useMaster from "libs/hooks/useMaster";
import translate from "libs/locale";
import TimePickerInDate from "./timePickerInDate";
import HorizontalCalendar from "./HorizontalCalendar";
import { View, StyleSheet } from "react-native";
import { getButtonModalWidth } from "../libs/utils/dimensions";
import AnimatedBottomSheet from "./animatedBottomSheet";

const MAX_DATE = 7;
const MAX_SELECTABLE_DATE = 3;
type Props = {
  open: boolean;
  serverTime: moment.Moment;
  close: (a?: string, b?: string) => void;
  selectedTime: number;
  selectedDate: string;
  setSelectedDate: (date: string) => void;
  setSelectedTime: (time: number) => void;

};
const DateTimePicker = (props: Props) => {
  const { open, serverTime, selectedTime, selectedDate, setSelectedDate, setSelectedTime, close } = props;

  const master = useMaster();
  const timeSlots =
    [
      ...(master?.data?.payload?.time_slots || []),
      {
        id: -1,
        name: translate("back"),
      },
    ] || [];


  const [openTime, steOpenTime] = useState(false);

  const onDateChange = (date: moment.Moment) => {
    setSelectedDate(date.local().format(DATE_FORMAT));
    steOpenTime(true);
  };

  const selectTime = (id: number) => {
    setSelectedTime(id);
    onClose(id);
  };

  const onClose = (timeId) => {
    steOpenTime(false);
    if (!(selectedTime || timeId)) {
      setSelectedDate(null);
      close(null, null);
    } else {
      close(selectedDate, timeId || selectedTime);
    }
  };

  return (
    <AnimatedBottomSheet
      isVisible={open}
      onBackdropPress={() => onClose(null)}
    >
      <View style={TABLET_PC && styles.tabletContainer}>
        {!openTime ? (
          <HorizontalCalendar
            selectedDate={selectedDate}
            setSelectedDate={onDateChange}
            maxDateLength={MAX_DATE}
            serverTime={serverTime || moment()}
            maxDate={MAX_SELECTABLE_DATE}
            timeSlots={timeSlots}
          />
        ) : (
          <TimePickerInDate
            selectedDate={selectedDate}
            serverTime={serverTime || moment()}
            timeSlots={timeSlots}
            selectedTime={selectedTime}
            selectTime={selectTime}
            steOpenTime={steOpenTime}
          />
        )}
      </View>
    </AnimatedBottomSheet>
  );
};

const styles = StyleSheet.create({
  tabletContainer: {
    alignSelf: "center",
    width: getButtonModalWidth(),
    borderTopLeftRadius: 15,
    borderTopRightRadius: 15,
    overflow: "hidden",
  },
});

export default DateTimePicker;
